import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { GridSortModel } from "@mui/x-data-grid"
import { RootState } from "./app/store"
import { FilterValues } from "./components/InvoicesTable/InvoiceFilterPanel"

export interface PaginationModel {
  page: number
  pageSize: number
}

export interface InvoicesState {
  filters: FilterValues
  filteredData: Record<string, any>
  invFilters: Record<string, any>
  sortModel: GridSortModel
  paginationModel: PaginationModel
}

export const initialFilterValues: FilterValues = {
  businessUnit: null,
  queueName: null,
  assignedUserEmail: null,
  invoiceStartDate: null,
  invoiceEndDate: null,
  invoiceAge: null,
  currency: null,
  invoiceAmountRange: null,
  supplierName: null,
  supplierSite: null,
}

const initialState: InvoicesState = {
  filters: initialFilterValues,
  filteredData: {},
  invFilters: {},
  sortModel: [],
  paginationModel: { page: 0, pageSize: 10 },
}

export const invoicesSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<FilterValues>) => {
      state.filters = action.payload
    },
    setFilteredData: (state, action: PayloadAction<Record<string, any>>) => {
      state.filteredData = action.payload
    },
    setInvFilters: (state, action: PayloadAction<Record<string, any>>) => {
      state.invFilters = action.payload
    },
    setSortModel: (state, action: PayloadAction<GridSortModel>) => {
      state.sortModel = action.payload
    },
    setPaginationModel: (
      state,
      action: PayloadAction<{ page: number; pageSize: number }>,
    ) => {
      state.paginationModel = action.payload
    },
    resetInvoicesState: () => initialState,
  },
})

export const {
  setFilters,
  setFilteredData,
  setInvFilters,
  setSortModel,
  setPaginationModel,
  resetInvoicesState,
} = invoicesSlice.actions

export const selectInvoicesFilters = (state: RootState) =>
  state.invoices.filters
export const selectFilteredData = (state: RootState) =>
  state.invoices.filteredData
export const selectInvFilters = (state: RootState) => state.invoices.invFilters
export const selectSortModel = (state: RootState) => state.invoices.sortModel
export const selectPaginationModel = (state: RootState) =>
  state.invoices.paginationModel

export default invoicesSlice.reducer
